<template>
  <transition appear name="fade-in">
    <img
      :src="require(`@/assets/img/png/logo-${game}.png`)"
      alt="Game Logo"
      class="logo"
    />
  </transition>
</template>

<script>
export default {
  props: {
    game: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
// ===================
//    animation
// ===================
.fade-in-enter {
  opacity: 0;
  // transition-delay: 1000ms;
}

.fade-in-enter-to {
  opacity: 1;
  transition: opacity 500ms ease-in;
  transition-delay: 1000ms;
}

// ===================
//    component
// ===================

a {
  text-align: center;
}

.logo {
  width: 25vw;
  margin: 0 auto 4vh auto;
}
</style>
